import { createPinia } from "pinia";

export const sharedPinia = createPinia();
